import { Dispatch, IAppState } from '../../../common/state';
import { setRegistrationTriggerCookie } from '../utils/setRegistrationTriggerCookie';

export enum ESignInTriggerModalActions {
  open = 'registrationTriggers/signInPopup/openModal',
  close = 'registrationTriggers/signInPopup/closeModal',
}

export interface IOpenSignInTriggerModal {
  type: ESignInTriggerModalActions.open;
}

export interface ICloseSignInTriggerModal {
  type: ESignInTriggerModalActions.close;
}

export function openSignInTriggerModal(): IOpenSignInTriggerModal {
  return {
    type: ESignInTriggerModalActions.open,
  };
}

export function closeSignInTriggerModal(): ICloseSignInTriggerModal {
  return {
    type: ESignInTriggerModalActions.close,
  };
}

export function showLoginPopup() {
  return (dispatch: Dispatch) => {
    dispatch(closeSignInTriggerModal());

    if (window.waitForLoginPopup) {
      window.waitForLoginPopup();
    }
  };
}

export function showRegistrationPopup() {
  return (dispatch: Dispatch) => {
    dispatch(closeSignInTriggerModal());

    if (window.waitForRegistrationPopup) {
      window.waitForRegistrationPopup();
    }
  };
}

export function setCookieAndShowTriggerPopup() {
  return (dispatch: Dispatch, getState: () => IAppState) => {
    if (!getState().user.isAuthenticated) {
      setRegistrationTriggerCookie();
      dispatch(openSignInTriggerModal());
    }
  };
}
